module.exports = __webpack_public_path__ + "01_long_brown.c43e3f12.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer5/01_long_brown.png
// module id = GrLg
// module chunks = 0